const ALPHABET = '0123456789abcdefghjkmnpqrstvwxyz'

/** Short, URL-safe, unambiguous id (Crockford-ish base32). 12 chars = 60 bits. */
export function newId(length = 12): string {
  const bytes = crypto.getRandomValues(new Uint8Array(length))
  let out = ''
  for (const b of bytes) out += ALPHABET.charAt(b % 32)
  return out
}
